module.exports = __webpack_public_path__ + "static/media/wildcard-rider-marker.c731d723.svg";